var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE6\x96\x87\xE4\xBB\xB6\xE6\xA0\xBC\xE5\xBC\x8F"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.23115 1.03558e-05C3.07497 -0.000655803 2.92031 0.0308237 2.77682 0.0924905C2.63332 0.154157 2.50404 0.244692 2.39704 0.358463C2.17835 0.582938 2.05079 0.880607 2.03907 1.19378V22.6956C2.03837 22.8519 2.06978 23.0067 2.13135 23.1504C2.19293 23.2941 2.28336 23.4236 2.39704 23.5309C2.50522 23.6432 2.63473 23.7327 2.77796 23.7943C2.9212 23.8558 3.07528 23.8881 3.23118 23.8894H20.7234C20.8796 23.8899 21.0342 23.8584 21.1777 23.7968C21.3212 23.7351 21.4505 23.6446 21.5576 23.5309C21.6695 23.4222 21.7587 23.2925 21.8201 23.1491C21.8816 23.0057 21.914 22.8516 21.9155 22.6956V6.76681L15.1568 1.03558e-05H3.23115Z",
    fill: "#6392FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.9189 6.7668H16.3538C15.7017 6.75119 15.1766 6.22596 15.1602 5.57304V0L21.9189 6.7668Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.9791 11.8828H10.6791C9.22102 11.8828 8.03906 13.0648 8.03906 14.5228C8.03906 15.9808 9.22102 17.1628 10.6791 17.1628H15.959C17.4171 17.1628 18.599 15.9808 18.599 14.5228C18.599 13.8533 18.3498 13.2419 17.939 12.7766",
    stroke: "white",
    strokeWidth: 0.989998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.05844 13.6245C5.64768 13.1591 5.39844 12.5478 5.39844 11.8783C5.39844 10.4202 6.5804 9.23828 8.03843 9.23828H13.3184C14.7765 9.23828 15.9584 10.4202 15.9584 11.8783C15.9584 13.3363 14.7765 14.5183 13.3184 14.5183H10.0184",
    stroke: "white",
    strokeWidth: 0.989998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.d181a0ac338950d17c45f17c6f5abba8.svg";
export { ForwardRef as ReactComponent };